module.exports = __webpack_public_path__ + "static/media/ODS16.f91df454.jpg";